import React, { Component } from "react";
import { Link } from "react-router-dom";
import data from "../../data/mainData.json";

class AboutV1 extends Component {
  render() {
    const publicUrl = process.env.PUBLIC_URL + "/";
    const { about } = data;

    return (
      <div className="ltn__about-us-area pt-3 pb-50">
        <div className="container">
          <div className="row">

           
            {/* <div className="col-lg-6 align-self-center">
              <div className="about-us-img-wrap about-img-left">
                <img src={publicUrl + "assets/img/others/7.png"} alt="About" />

                <div className="about-us-img-info about-us-img-info-2 about-us-img-info-3">
                  <div className="ltn__video-img ltn__animation-pulse1">
                    <img
                      src={publicUrl + "assets/img/others/8.png"}
                      alt="Video"
                    />
                    <a
                      className="ltn__video-icon-2 ltn__video-icon-2-border---"
                      href={about.videoUrl}
                      data-rel="lightcase:myCollection"
                    >
                      <i className="fa fa-play" />
                    </a>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="col-lg-6 align-self-start">
              <div className="about-us-img-wrap about-img-left">
                <video
                  width="100%"
                  height="auto"
                  controls
                  controlsList="nodownload"
                  disablePictureInPicture
                  onContextMenu={(e) => e.preventDefault()}
                  autoPlay
                  loop
                  muted
                  src={about?.videoUrl}
                >
                  
                </video>
              </div>
              <ul className="ltn__list-item-half clearfix">
                  {about.features.map((item, index) => (
                    <li key={index}>
                      <i className={item.icon} /> {item.text}
                    </li>
                  ))}
                </ul>
            </div>


            {/* Content Section */}
            <div className="col-lg-6 align-self-center">
              <div className="about-us-info-wrap">
                <div className="section-title-area ltn__section-title-2--- mb-20">
                  <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                    {about.subtitle}
                  </h6>
                  <h1 className="section-title">
                    {about.titleLine1}
                    <br />
                    {about.titleLine2}
                    <span>.</span>
                  </h1>
                  <p>{about.description}</p>
                </div>

              

                {/* Quote */}
                {/* <div className="ltn__callout bg-overlay-theme-05 mt-30">
                  <p>"{about.quote}"</p>
                </div> */}

                {/* <div className="btn-wrapper animated go-top">
                  <Link
                    to={about.buttonLink}
                    className="theme-btn-1 btn btn-effect-1"
                  >
                    {about.buttonText}
                  </Link>
                </div> */}
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default AboutV1;
